import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { fetchCountries } from '../actions/countries.actions';
import ListState from '../states/list.state';

const initialState: ListState = {
  data: [],
  loading: false,
  error: null,
  meta: null,
};

const countriesSlice = createSlice({
  name: 'countries',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCountries.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCountries.fulfilled, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.data = action.payload.data;
      })
      .addCase(fetchCountries.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload ?? null;
      });
  },
});

export default countriesSlice.reducer;